// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2QR-pXImNM6rAI {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n._2QR-pXImNM6rAI button {\n  flex: 1;\n  overflow: hidden;\n  margin-right: 8px;\n}\n._2QR-pXImNM6rAI button:last-child {\n  margin-right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": "_2QR-pXImNM6rAI"
};
export default ___CSS_LOADER_EXPORT___;
